import AppDialog from './AppDialog'

export default AppDialog